<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <!--banners></!--banners-->
    <div class="box-interno conteudoGenerico detalheProduto" v-if="dados">
      <div class="container pb-4 pt-2">
        <div class="pt-3">
          <div href="#" v-if="dados.nomeLoja">
            <p>
              Promoção da loja:
              <b :style="`color:${dados.corLoja};`"> {{ dados.nomeLoja }}</b>
            </p>
          </div>
          <div
            class="d-grid iconDestaquesCaixa"
            v-if="
              dados.destaque ||
                dados.descontoProgressivo ||
                dados.ofertaRelampago ||
                dados.ofertaExclusivaPrime ||
                dados.compraRecorrenteComMaisDesconto
            "
          >
            <div class="d-flex item" v-if="dados.ofertaRelampago">
              <img class="iconbox mb-1" src="@/assets/relampago.png" />
              <span>Oferta Relâmpago</span>
            </div>
            <div class="d-flex item" v-if="dados.destaque">
              <img class="iconbox mb-1" src="@/assets/fire.png" />
              <span>Oferta Destaque</span>
            </div>
            <div class="d-flex item" v-if="dados.descontoProgressivo">
              <img class="iconbox mb-1" src="@/assets/desconto.png" />
              <span>Oferta com Desconto Progressivo</span>
            </div>
            <div class="d-flex item" v-if="dados.ofertaExclusivaPrime">
              <img class="iconbox mb-1" src="@/assets/exclusivo-prime.png" />
              <span>Oferta Exclusiva Prime</span>
            </div>
            <div
              class="d-flex item"
              v-if="dados.compraRecorrenteComMaisDesconto"
            >
              <img class="iconbox mb-1" src="@/assets/recorrente.png" />
              <span>Recorrente com mais Desconto</span>
            </div>
          </div>
        </div>
        <div class="text-center">
          <img
            :src="dados.imagem"
            class="productImage"
            loading="lazy"
            :title="dados.nomeProduto"
            :alt="dados.nomeProduto"
          />
        </div>
        <div class="mt-2" :title="`em ${dados.createdAt}`">
          <div class="time text-left">
            há {{ diferencaHoras(dados.createdAt) }}
          </div>
        </div>
        <h1 class="nomeCaixa mt-1">
          {{ dados.nomeProduto }}
        </h1>

        <div class="valores">
          <span class="badge-valor-old">
            de: {{ dados.valorOld | currency }}
          </span>
          <div class="col-valor">
            <span class="badge-valor"> por: {{ dados.valor | currency }} </span>
          </div>
        </div>

        <div class="fretes mt-3">
          <span class="badge text-dark mr-2" v-if="dados.freteGratis"
            ><i class="fas fa-truck mr-2"></i>Frete Grátis</span
          >
          <span class="badge text-dark  mr-2" v-if="dados.freteGratisPrime"
            ><i class="fas fa-truck mr-2"></i>Frete Prime</span
          >
          <span class="badge text-dark  mr-2" v-if="dados.freteGratisRetirada"
            ><i class="fas fa-truck mr-2"></i>Retire na Loja sem pagar
            Frete</span
          >
        </div>

        <p class="descricao mt-1" v-html="dados.descricao"></p>
        <div class="botoes">
          <div class="my-3" v-if="dados.cupom">
            <p>Utilize o Cupom para ganhar desconto</p>
            <div class="input-group ">
              <input
                name="qr code"
                v-model="dados.cupom"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  @click="copiarDados(dados.cupom)"
                  class="btn  btn-dark text-white"
                  type="button"
                  id="button-addon2"
                  style="background-color: black !important;"
                >
                  <i class="fa fa-copy"></i> Copiar Cupom
                </button>
              </div>
            </div>
          </div>
          <a
            v-if="dados.nomeLoja"
            :href="dados.linkEntrada"
            @click="registraClick()"
            target="_blank"
            class="btn btn-block btnComprar"
            :style="
              `background-color:${dados.corLoja}; color:${dados.corTextoLoja}`
            "
            ><span>Comprar {{ dados.prefixo }} {{ dados.nomeLoja }}</span
            ><i class="fa fa-arrow-up-right-from-square ml-3"></i
          ></a>
          <a
            v-else
            :href="dados.linkEntrada"
            @click="registraClick()"
            target="_blank"
            class="btn btn-block btnComprar"
            ><span>Comprar</span
            ><i class="fa fa-arrow-up-right-from-square ml-3"></i
          ></a>
          <p class="disponibilidade">
            *Preço e disponibilidade sujeito a alteração a qualquer momento.
          </p>
        </div>
      </div>

      <div>
        <div v-if="promocoesSemelhantes.length > 0">
          <PromocoesSemelhantes
            class="p-2 mb-3"
            :promocoesSemelhantes="promocoesSemelhantes"
          ></PromocoesSemelhantes>
        </div>
      </div>
    </div>
    <div v-else-if="naoEncontrada" class="box-interno mt-1">
      <h3 class="text-center mb-5 pb-5 mt-3">Promoção não Encontrada</h3>
    </div>
  </div>
</template>

<script>
//import banners from './componentes/banners.vue';
import { Parallax, Button, Switch, Modal, Checkbox } from '@/components';
import PromocoesSemelhantes from './componentes/PromocoesSemelhantes.vue';
import service from '../services';
import storage from '../services/storage';
import swal from 'sweetalert';
import { KEY_LOCAL_STORAGE } from './../const';
import jwt from 'jsonwebtoken';
import moment from 'moment';
export default {
  name: 'promocoesDetalhes',
  bodyClass: 'promocoesDetalhes',
  metaInfo() {
    const title = 'Promoção - ' + this.dados.nomeProduto;

    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: title,
        },
        /* {
          property: 'og:title',
          content: title,
          vmid: 'og:title',
        },
        {
          property: 'og:image',
          content: `${this.dados ? this.dados.imagem : ''}`,
          vmid: 'og:image',
        },
        {
          property: 'og:description',
          content: `${this.dados ? this.dados.descricao : ''}`,
          vmid: 'og:description',
        },*/
      ],
    };
  },
  components: {
    PromocoesSemelhantes,
    //banners,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      showHeader: true,
      showFooter: true,
      dados: null,
      promocoesSemelhantes: [],
      iconeCarregando: service.getEnvIconeCarregando(),
      aberturaRapida: false,
      sortear: false,
      simular: false,
      carregando: false,
      exibeErro: false,
      msgErro: '',
      textoBotao: '',
      disabled: false,
      saldoInsuficiente: false,
      needsLogin: false,
      isSimulacao: false,
      naoEncontrada: false,
      valorFaltante: null,
      linkAtual: this.getLink(),
    };
  },
  methods: {
    getLink() {
      return window.location.href;
    },
    copiarDados(cupom) {
      //O texto que será copiado
      const texto = cupom;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);

      //swal('=)', 'QR Code foi copiado para a área de Transfêrencia', 'success')
      swal({
        title: '=)',
        text: 'Cupom foi copiado para a área de Transfêrencia',
        type: 'success',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 3000,
        closeOnConfirm: false,
      });
    },
    diferencaHoras(diahora) {
      const now = moment(new Date()); //todays date
      const end = moment(diahora); // another date
      const duration = moment.duration(now.diff(end));
      let horas = duration.asHours();
      let dias = duration.asDays();
      return horas < 24 ? +Math.round(horas) + 'h' : Math.round(dias) + ' dias';
    },
    verificaDecoded() {
      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);

      if (token) {
        this.decoded = jwt.decode(token);
      }
    },
    buscaPromocoesSemelhantes() {
      const categoria = this.dados.idCategoria;
      const action = categoria ? 'offers?categoryId=' + categoria : 'offers';
      service.getAll('superOfertas', null, action).then(res => {
        this.promocoesSemelhantes = (res.data || [])
          .filter(item => String(item.id) !== String(this.dados.id))
          .slice(0, 12);
      });
    },
    async registraClick() {
      console.log('pega click');
      const ipStorage = storage.lerStorage('ip');
      const ip = ipStorage ? ipStorage : await service.getIP();
      /*service.post('Promocoes', 'salvaClick', {
        idPromocao: this.dados.idPromocao,
        click: true,
        ip: ip,
      });*/
    },
    async buscaDados(refresh = false) {
      if (storage.lerStorage('showFooter') == 'false') {
        this.showFooter = false;
      }
      if (storage.lerStorage('showHeader') == 'false') {
        this.showHeader = false;
      }
      // rota /p/:produto agora carrega a URL do produto (final_link) decodificada
      const url = this.$route.params.produto;

      const dadosPromocao = JSON.parse(storage.lerStorage('pr'));

      if (dadosPromocao && url == dadosPromocao.url) {
        this.dados = dadosPromocao;
      } else {
        this.carregando = true;
        const ip = await service.getIP();
        storage.escreveStorage('ip', ip);

        service
          .getAll('superOfertas', null, 'offer?url=' + encodeURIComponent(url))
          .then(res => {
            this.carregando = false;
            if (res.data && res.data.id) {
              this.dados = res.data;
              document.title = 'Promoção - ' + this.dados.nomeProduto;

              const ogTitle = document.getElementById('og-title');
              if (ogTitle)
                ogTitle.content = 'Promoção - ' + this.dados.nomeProduto;

              const ogUrl = document.getElementById('og-url');
              if (ogUrl) ogUrl.content = this.dados.linkEntrada;

              const ogImage = document.getElementById('og-image');
              if (ogImage) ogImage.content = this.dados.imagem;

              if (!refresh) this.buscaPromocoesSemelhantes();
            } else this.naoEncontrada = true;
          })
          .catch(error => {
            this.naoEncontrada = true;
            this.msgErro = ' ' + error;
            this.carregando = false;
            swal('ops!', this.msgErro, 'error');
            this.showModal = false;
          });
      }
    },
  },

  beforeCreate() {
    const dadosPromocao = JSON.parse(storage.lerStorage('pr'));
    // acesso direto por link compartilhado (/p/:url) pode não ter 'pr' em cache;
    // nesse caso o buscaDados() preenche as og tags depois de carregar a oferta.
    if (!dadosPromocao) return;
    const ogTitle = document.getElementById('og-title');
    if (ogTitle) ogTitle.content = dadosPromocao.nomeProduto;

    const ogUrl = document.getElementById('og-url');
    if (ogUrl) ogUrl.content = dadosPromocao.linkEntrada;

    const ogImage = document.getElementById('og-image');
    if (ogImage) ogImage.content = dadosPromocao.imagem;

    const ogSiteName = document.getElementById('og-site_name');
    if (ogSiteName) ogSiteName.content = storage.lerStorage('nomeEmpresa');

    const ogDescription = document.getElementById('og-description');
    if (ogDescription)
      ogDescription.content =
        storage.lerStorage('nomeEmpresa') + ' - Super Ofertas';
    /*
    const twitterSite = document.getElementById('twitter-site');
    if (twitterSite)
      twitterSite.content = redesSociais.twitter
        ? redesSociais.twitter
        : dadosPromocao.linkEntrada;

    const twitterTitle = document.getElementById('twitter-title');
    if (twitterTitle) twitterTitle.content = dadosPromocao.nomeProduto;

    const twitterDescription = document.getElementById('twitter-description');
    if (twitterDescription)
      twitterDescription.content =
        storage.lerStorage('nomeEmpresa') + ' - Super Ofertas';
*/
    const metaDescription = document.getElementById('meta-description');
    if (metaDescription)
      metaDescription.content =
        storage.lerStorage('nomeEmpresa') + ' - Super Ofertas';
  },
  created() {
    this.verificaDecoded();
    this.buscaDados();
  },
};
</script>
<style lang="scss">
.iconDestaquesCaixa {
  display: grid;

  margin-bottom: 20px;
  .item {
    border: 1px solid #ebebeb;
    border-radius: 5px;
    padding: 5px;
    align-items: center;
    .iconbox {
      width: 32px !important;
      margin-right: 10px;
    }
  }
}
</style>
<style>
.detalheProduto .botoes {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  z-index: 999;
}
@media (max-width: 768px) {
  .detalheProduto .botoes {
    bottom: 100px;
  }
}
.detalheProduto .botoes p {
  font-size: 0.8em;
  text-align: center;
}
.box-interno {
  padding: calc(v-bind(showHeader? '84px': '0px') + 1rem) 1rem 0;
}

.input-group-text {
  height: 44px;
  padding-right: 10px;
}

.input-group > .input-group-append > .btn {
  margin: 0px;
}
.containerRoleta {
  min-height: 300px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
/*
.containerRoleta::before {
  content: '';
  position: absolute;
  inset: 0;
}*/
.detalheProduto {
  h1 {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .badge-valor,
  .badge-valor-old {
    font-size: 1.6em;
    border-radius: 0rem;
    margin: 5px;
    line-height: 1.625rem !important;
    border: 0;
    transition: background-color 0.5s ease;
    font-weight: bold;
  }

  .badge-valor-old {
    font-size: 0.9em;
    text-decoration: line-through;
    font-weight: normal;
    padding-top: 8px !important;
  }

  .btnComprar {
    /* margin-top: 20px !important;*/
    padding: 10px 30px !important;
  }

  .productImage {
    max-width: 400px;
  }
}

@media (max-width: 766px) {
  .detalheProduto {
    .productImage {
      max-width: 100% !important;
    }
  }
}
</style>
